
import { defineComponent } from 'vue'
import { FileImageOutlined, LoadingOutlined } from '@ant-design/icons-vue'
import { commonUploadCheck } from '../helper'
import Uploader from './Uploader.vue'
export default defineComponent({
  components: {
    Uploader,
    FileImageOutlined,
    LoadingOutlined
  },
  props: {
    text: {
      type: String,
      default: '上传图片'
    },
    showUploaded: {
      type: Boolean,
      default: false
    }
  },
  emits: ['success'],
  setup(props, { emit }) {
    const handleUploadSuccess = (resp: any, file: File) => {
      emit('success', { resp, file })
    }
    return {
      commonUploadCheck,
      handleUploadSuccess
    }
  }
})
